<template>
    <div>
        <v-card outlined class="mb-4" v-for="(assetCheck,i) in indexedAssetCheck" :key="i">
            <v-card-text>
                <div class="title mb-5 d-flex align-center">
                    <v-img class="mr-2" contain v-if="indexedAssetCheck.length > 0" :src="assetCheck.asset.icongraphic || icongraphicPlaceholder" max-width="35" width="35" height="35"></v-img>
                    {{ assetCheck.asset.name }}
                </div>
                <!-- Checker -->
                <div v-if="checkProfile(assetCheck.checker, assetCheck.verifier) == 'checker'">
                    <div v-if="!assetCheck.checker_data_complete">
                        <v-alert type="info">
                        You can proceed to check now.
                        </v-alert>
                    </div>
                    <div v-if="assetCheck.checker_data_complete">
                        <v-alert type="success">
                        This asset is checked.
                        </v-alert>
                    </div>
                    <paramCheckTable 
                    v-if="assetCheck.id && additionalDataLoaded && assetCheck.parameter_check_set.length > 0" 
                    :assetListFull="assetListFull" 
                    :baseParamList="baseParamList"
                    :masterParamList="masterParamList"
                    :unitList="unitList"
                    :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                    :checkverifyStatus="checkverifyStatus" 
                    :assetCheckId="assetCheck.id" 
                    :assetId="assetCheck.asset.id"
                    v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)"
                    >
                    </paramCheckTable>
                    <v-divider></v-divider>
                    <compCheckTable 
                    v-if="assetCheck.id && additionalDataLoaded && assetCheck.component_check_set.length > 0" 
                    :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                    :componentList="componentList"
                    :checkverifyStatus="checkverifyStatus" 
                    :assetCheckId="assetCheck.id" 
                    :assetId="assetCheck.asset.id"
                    :compCheckList="assetCheck.component_check_set"
                    v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)">
                    </compCheckTable>
                </div>
                <!-- Verifier -->
                <div v-if="checkProfile(assetCheck.checker, assetCheck.verifier) == 'verifier'" >
                    <div v-if="!assetCheck.checker_data_complete">
                        <v-alert type="info">
                        This checklist is not fully checked yet.
                        </v-alert>
                    </div>
                    <div v-if="(assetCheck.checker_data_complete && !assetCheck.verifier_data_complete)">
                        <v-alert type="info">
                        This asset is checked and ready to be verified.
                        </v-alert>
                    </div>
                    <div v-if="(assetCheck.verifier_data_complete)" >
                        <v-alert type="success">
                        This asset is checked and verified.
                        </v-alert>
                    </div>
                    <div v-if="(checkverifyStatus == 'CHECKED' || checkverifyStatus == 'VERIFIED')" >
                        <paramCheckTable 
                        v-if="assetCheck.id && additionalDataLoaded && assetCheck.parameter_check_set.length > 0" 
                        :assetListFull="assetListFull" 
                        :baseParamList="baseParamList"
                        :masterParamList="masterParamList"
                        :unitList="unitList"
                        :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                        :checkverifyStatus="checkverifyStatus" 
                        :assetCheckId="assetCheck.id" 
                        :assetId="assetCheck.asset.id"
                        v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)">
                        </paramCheckTable>
                        <v-divider></v-divider>
                        <compCheckTable 
                        v-if="assetCheck.id && additionalDataLoaded && assetCheck.component_check_set.length > 0" 
                        :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                        :checkverifyStatus="checkverifyStatus" 
                        :componentList="componentList"
                        :assetCheckId="assetCheck.id" 
                        :assetId="assetCheck.asset.id"
                        :compCheckList="assetCheck.component_check_set"
                        v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)">
                        </compCheckTable>
                    </div>
                </div>
                <!-- Super -->
                <div v-if="checkProfile(assetCheck.checker, assetCheck.verifier) == 'super'" >
                    <div v-if="!assetCheck.checker_data_complete">
                        <v-alert type="info">
                        This checklist is not fully checked yet.
                        </v-alert>
                    </div>
                    <div v-if="(assetCheck.checker_data_complete && !assetCheck.verifier_data_complete)">
                        <v-alert type="info">
                        This asset is checked and ready to be verified.
                        </v-alert>
                    </div>
                    <div v-if="(assetCheck.verifier_data_complete)" >
                        <v-alert type="success">
                        This asset is checked and verified.
                        </v-alert>
                    </div>
                    <div>
                        <paramCheckTable 
                        v-if="assetCheck.id && additionalDataLoaded && assetCheck.parameter_check_set.length > 0" 
                        :assetListFull="assetListFull" 
                        :baseParamList="baseParamList"
                        :masterParamList="masterParamList"
                        :unitList="unitList"
                        :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                        :checkverifyStatus="checkverifyStatus" 
                        :assetCheckId="assetCheck.id" 
                        :assetId="assetCheck.asset.id"
                        v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)">
                        </paramCheckTable>
                        <v-divider></v-divider>
                        <compCheckTable 
                        v-if="assetCheck.id && additionalDataLoaded  && assetCheck.component_check_set.length > 0" 
                        :profileType="checkProfile(assetCheck.checker, assetCheck.verifier)" 
                        :checkverifyStatus="checkverifyStatus" 
                        :componentList="componentList"
                        :assetCheckId="assetCheck.id" 
                        :assetId="assetCheck.asset.id"
                        :compCheckList="assetCheck.component_check_set"
                        v-on:reloadAssetCheck="refreshAssetCheck(assetCheck.id, assetCheck.index)">
                        </compCheckTable>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
    
</template>
<script>
import Vue from 'vue'
import compCheckTable from '@/components/check/comp-check-list'
import paramCheckTable from '@/components/check/param-check-list'
	export default {
        props: {
            checklistId: {
                type: Number
            },
            profileId: {},
            checkverifyStatus: String,
            assetCheckList: Array,
        },
        components: {
            compCheckTable,
            paramCheckTable
        },
		data() {
            return {
                headersAssetCheck: [
                {
                    text: 'Asset',
                    align: 'left',
                    sortable: true,
                    value: 'asset',
                },
                { text: 'Checker', value: 'checker', width: '200px' },
                { text: 'Verifier', value: 'verifier', width: '200px' },
                { text: 'Order', value: 'sort_order', width:'100px' },
                { text: ''}
                ],
                id: [],
                loading: true,
                assetChecksbyChecklist: [],
                users:[],
                assetListFull: [],
                masterParamList: [],
                baseParamList: [],
                componentList: [],
                unitList:[], 
                additionalDataLoaded: false,
            }
        },
        computed: {
            indexedAssetCheck () {
                if (this.profileId == 0) {
                    return this.assetCheckList;
                }else {
                    return this.assetCheckList.filter((checklist => checklist.checker == this.profileId || checklist.verifier == this.profileId) );
                }
            },
        },
        methods: {
            list() {
                if (this.checklistId) {
                    // this.getAssetChecksbyChecklist().then((res) => {
                    //     this.assetChecksbyChecklist = res;
                    //     res.forEach((item, i) => {
                    //         Vue.set(item,'index', i);
                    //     })
                    // });
                }
            },
            refreshAssetCheck(id, index) {
                if (id) {
                    this.getAssetCheck(id).then((res) => {
                        Vue.set(this.assetChecksbyChecklist[index],'checker_data_complete', res.checker_data_complete);
                        Vue.set(this.assetChecksbyChecklist[index],'verifier_data_complete', res.verifier_data_complete);
                    });
                }
            },
			async getAssetChecksbyChecklist() {
                try {
                    this.loading = true
                    const res = await this.$api.assetCheck.search({ checklist: this.checklistId, ordering: 'sort_order'});
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
			async getAssetCheck(id) {
                try {
                    this.loading = true
                    const res = await this.$api.assetCheck.get( id );
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    this.loading = false
                }
            },
            getAdditionalData() {
			    this.getUsers().then(res => this.users = res);
			    this.getUnitList().then(res => this.unitList = res);
			    this.getMastParam().then(res => this.masterParamList = res);
                this.getBaseParameters().then(res => this.baseParamList = res);
                this.additionalDataLoaded = true;
            },
			async getUsers() {
                try {
                    const res = await this.$api.user.listNameRef();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
			async getUnitList() {
                try {
                    const res = await this.$api.unit.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
			async getAssets() {
                try {
                    const res = await this.$api.asset.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
			async getMastParam() {
                try {
                    const res = await this.$api.mastParam.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
			async getBaseParameters() {
                try {
                    const res = await this.$api.baseParam.list();
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
			async getCompsbyAsset() {
                try {
                    const res = await this.$api.component.search({ asset: this.assetId });
                    return res.data;
                } catch (error) {
                    // handle error
                } finally {
                    // req done
                }
            },
            getUserName(user_id) {
                if ( this.users.length !== 0 && user_id ) {
                    return this.users.find(user => user.id === user_id).username;
                }
            }, 
            newAssetCheck() {
                // this.$router.push({ name: 'assetCheckForm', params: {checklistId: this.checklistId } })
                this.assetChecksbyChecklist.push({id: '', asset: '', checklist: this.checklistId, asset: '', checker: '', sort_order: '' });
            },
            edit (id) {
                this.$router.push({ name: 'assetCheckForm', params: { id: id, checklistId: this.checklistId } })
            },
            save(id, asset, checker, verifier, sort_order) {
                this.saveAssetCheck(id, asset, checker, verifier, sort_order).then((res) => {
                    if (res.status == 200 || res.status == 201 ) {
                        this.$swal({
                            icon: 'success',
                            title: 'Saved',
                            confirmButtonText: 'Ok',
                        }).then((result) => {
                            this.list();
                        })
                    }
                });
			},
			async saveAssetCheck(id, asset, checker, verifier, sort_order) {
                try {
                    let res;
                    this.saving = true
                    if (id) {
                        res = await this.$api.assetCheck.save( {id: id, asset: asset, checker: checker, verifier: verifier, sort_order: sort_order, checklist: this.checklistId });
                    } else {
                        res = await this.$api.assetCheck.new({id: id, asset: asset, checker: checker, verifier: verifier, sort_order: sort_order, checklist: this.checklistId });
                    }
                    return res;
                } catch (error) {
                    // handle error
                } finally {
                    this.saving = false
                }
            },
            remove(index, id) {
                if (id !== '') {
                    this.$swal({
                        icon: 'warning',
                        title: 'Are you sure to delete this?',
                        showCancelButton: true,
                        reverseButtons: true,
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'No',
                    }).then((result) => {
                        if (result.value) {
                            this.$api.assetCheck.delete(id).then((res) => {
                                this.list();
                            });
                        }
                    })
                } else {
                    this.$delete(this.assetChecksbyChecklist, index)
                }
            },
            checkProfile(checker, verifier) {
                if (this.profileId == checker) {
                    return 'checker'
                }
                if (this.profileId == verifier) {
                    return 'verifier'
                }
                if (parseInt(this.profileId) == 0) {
                    return 'super'
                }
            }
        },
        mounted(){
            this.getAdditionalData();
            this.list();
        },
        watch: {
            profileId(id) {
                this.checkProfile();
                this.list();
            }
        }
    }
</script>